import { electricPurple600, electricPurple100, spanishViridian600 } from '@habitech/shared';

import {
  SubjectCardWrapper,
  SubjectCardHeader,
  SubjectDot,
  SubjectCardTitle,
  CardRow,
  CardRowLabel,
  CardRowValue,
  LegendWrapper,
  LegendTitle,
  LegendItem,
  LegendDot,
  LegendBadge,
  LegendPolygonSwatch,
  NoDataNotice,
} from './styles';

const formatPrice = (val: number) =>
  '$' + Math.round(val).toLocaleString('es-MX');

interface SubjectCardProps {
  nid: string;
  lat: number | null;
  lng: number | null;
  askPrice: number | null;
  askPriceM2: number | null;
  percentil: number | null;
  comparablesCount: number;
  hasPolygon?: boolean;
}

export const SubjectCard = ({
  nid, lat, lng,
  askPrice, askPriceM2, percentil,
  comparablesCount, hasPolygon,
}: SubjectCardProps) => {
  return (
    <>
      <SubjectCardWrapper>
        <SubjectCardHeader>
          <SubjectDot />
          <SubjectCardTitle>Inmueble Sujeto</SubjectCardTitle>
        </SubjectCardHeader>
        <CardRow>
          <CardRowLabel>NID</CardRowLabel>
          <CardRowValue $purple>{nid}</CardRowValue>
        </CardRow>
        <CardRow>
          <CardRowLabel>Latitud</CardRowLabel>
          <CardRowValue>{lat != null ? lat.toFixed(6) : 'N/A'}</CardRowValue>
        </CardRow>
        <CardRow>
          <CardRowLabel>Longitud</CardRowLabel>
          <CardRowValue>{lng != null ? lng.toFixed(6) : 'N/A'}</CardRowValue>
        </CardRow>

        {askPrice != null && (
          <CardRow>
            <CardRowLabel>Ask Habi</CardRowLabel>
            <CardRowValue>{formatPrice(askPrice)}</CardRowValue>
          </CardRow>
        )}

        {askPriceM2 != null && (
          <CardRow>
            <CardRowLabel>Ask Habi / m²</CardRowLabel>
            <CardRowValue>{formatPrice(askPriceM2)}</CardRowValue>
          </CardRow>
        )}

        {percentil != null && (
          <CardRow>
            <CardRowLabel>Percentil</CardRowLabel>
            <CardRowValue>
              <span style={{
                background: electricPurple100,
                color: electricPurple600,
                fontWeight: 700,
                padding: '1px 7px',
                borderRadius: '4px',
                fontSize: '11px',
              }}>
                p{percentil}
              </span>
            </CardRowValue>
          </CardRow>
        )}

        {comparablesCount === 0 && (
          <NoDataNotice>
            ℹ️ Este NID no tiene comparables registrados para el último ejercicio de pricing.
          </NoDataNotice>
        )}

        {!hasPolygon && (
          <NoDataNotice>
            ℹ️ No hay polígono de búsqueda disponible para este NID.
          </NoDataNotice>
        )}
      </SubjectCardWrapper>

      <LegendWrapper>
        <LegendTitle>Referencias</LegendTitle>
        <LegendItem>
          <LegendDot $color={electricPurple600} />
          <span>Inmueble sujeto</span>
        </LegendItem>
        <LegendItem>
          <LegendDot $color={spanishViridian600} />
          <span>
            Comparables{' '}
            <LegendBadge>{comparablesCount}</LegendBadge>
          </span>
        </LegendItem>
        {hasPolygon && (
          <LegendItem>
            <LegendPolygonSwatch $color={electricPurple600} />
            <span>Área de búsqueda</span>
          </LegendItem>
        )}
      </LegendWrapper>
    </>
  );
};
